import { render, staticRenderFns } from "./WeekEquipment.vue?vue&type=template&id=2cffed23&scoped=true&"
import script from "./WeekEquipment.vue?vue&type=script&lang=js&"
export * from "./WeekEquipment.vue?vue&type=script&lang=js&"
import style0 from "./WeekEquipment.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WeekEquipment.vue?vue&type=style&index=1&id=2cffed23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffed23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VFabTransition,VForm,VIcon,VRow,VSelect,VSpacer,VTextField})
